import { Section } from "../view/section";
import { FormField, FormInput } from "./form-field";
import { ImageryOptionsPanel } from "./imagery/imagery-options-panel";
import { ImagerySlotsRow } from "./imagery/imagery-slots-row";
import { SectionPhotosForm } from "./section-photos-form";

interface Props {
  recordId: string | undefined;
  latitude: number | null;
  longitude: number | null;
  imagesIntro: string;
  onImagesIntroChange: (value: string) => void;
}

export function SectionImagesForm({
  recordId,
  latitude,
  longitude,
  imagesIntro,
  onImagesIntroChange,
}: Props): React.ReactElement {
  return (
    <Section id="images" title="Images">
      <div className="space-y-5">
        <FormField label="Images Intro" htmlFor="imagesIntro">
          <FormInput
            id="imagesIntro"
            value={imagesIntro}
            onChange={(e) => onImagesIntroChange(e.target.value)}
            placeholder="The following images have been sourced from..."
            data-testid="images-intro-input"
          />
        </FormField>

        <ImagerySlotsRow recordId={recordId} />

        <ImageryOptionsPanel recordId={recordId} latitude={latitude} longitude={longitude} />

        <div>
          <p className="text-xs font-medium text-muted-foreground mb-2">Additional Photos</p>
          {recordId ? (
            <SectionPhotosForm recordId={recordId} />
          ) : (
            <p
              className="text-sm text-muted-foreground text-center py-4 border rounded-md"
              data-testid="images-photos-unsaved-hint"
            >
              Save the record first to add photos.
            </p>
          )}
        </div>
      </div>
    </Section>
  );
}
